import { CONSTANTS } from 'client/utils/constants';
import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import { GET_CART_ORDERS, GET_ORDER_BY_ID, GET_DELETE_CART_ORDER } from '../../Store/OrderManagement/Order/OrderType';
import { setCartOrders, setOrderById, setDeleteCartOrder, setCartCount } from 'Store/OrderManagement/Order/OrderAction';
import { CREATE_ORDER_REQUEST, } from 'Store/Component/Requisition/RequisitionType';
import OrderManagementApiService from './OrderManagementApiService';
import { GET_CART_COUNT } from 'Store/OrderManagement/Order/OrderType';
import { setGlobalLoader } from 'Store/Component/GlobalLoader/GlobalLoaderAction';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
function* createOrderRequest(orderRequest: any): any {
    try {
        if (orderRequest?.orderRequest?.orderAction == CONSTANTS.ORDER_SAVE) {
            yield put(globalLoaderText("Saving Order ...."));
        } else if (orderRequest?.orderRequest?.orderAction == CONSTANTS.ORDER_SUBMIT) {
            yield put(globalLoaderText("Creating Order ...."));
        }

        let payloadData : IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.OrderManagement,
            endpoint: `orders`,
            payload: orderRequest.orderRequest
          }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
            
        );

        if (response?.orderId == null) {
            yield put(RequisitionAction.setIsOrderCreationSuccess(response));
            yield put(globalLoaderText(""));
        }
        else {
            yield put(RequisitionAction.setOrderLeadrNumber(response?.orderId));
            yield put(RequisitionAction.setIsOrderCreationSuccess(response));
            yield put(RequisitionAction.setIsMandFlag(false));
            yield put(RequisitionAction.setIsApprovalOverrideFlag(false));
            yield put(RequisitionAction.setIsDealerSameForAllFlagFlag(false));
            RequisitionAction.setIOrderRequest("");
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(RequisitionAction.setIsOrderCreationSuccess({
            orderId: null,
            errorMessage:""
        }));
    }
}

function* getOrderById(req: any): any {
    let orderId = req.val;
    let state = yield select();
    let payloadData : IPayload = {
        apiType : apiType.OrderManagement,
        endpoint : `orders/${orderId}`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    
    try {
        yield put(setGlobalLoader({...state.GlobalLoaderReducer, orderDetail: true}));     
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp,payloadData
        );
        yield put(setOrderById(response))
        yield put(setGlobalLoader({...state.GlobalLoaderReducer, orderDetail: false}));     

    } catch (error) {
        yield put(setOrderById([]))
        yield put(setGlobalLoader({...state.GlobalLoaderReducer, orderDetail: false}));
    }
}

function* getCartCountSaga(req: any): any {
 let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `orders/cartcount/${req.emailId}`,
        payload : null
      }
    try {
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCartCount(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setCartCount(0))
        yield put(globalLoaderText(""));
    }
}

function* getCartOrderSaga(req: any): any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `orders/draft/${req.emailId}`,
        payload : null
      }
        
    try {
        yield put(globalLoaderText("Getting orders..."));
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCartOrders(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setCartOrders([]))
        yield put(globalLoaderText(""));
    }
}
function* deleteCartDraftSaga(req: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `orders/deleteOrder`,
        payload : req?.draftOrderId
    }
    try {
        yield put(globalLoaderText("Deleting Draft...."));
      const response = yield call(
        OrderManagementApiService.post,
        API_URL.PostWebApp, payloadData
      );
      yield put(setDeleteCartOrder(response));
      yield put(globalLoaderText(""));
    }catch (error) {
      yield put(setDeleteCartOrder(false));
      yield put(globalLoaderText(""));
    }
  }

function* watchOrder() {
    yield takeEvery(CREATE_ORDER_REQUEST, createOrderRequest);
    yield takeEvery(GET_ORDER_BY_ID, getOrderById);
    yield takeEvery(GET_CART_COUNT, getCartCountSaga);
    yield takeEvery(GET_CART_ORDERS, getCartOrderSaga)
    yield takeEvery(GET_DELETE_CART_ORDER, deleteCartDraftSaga)
}

export default function* combinedSaga() {
    yield all([
        watchOrder()
    ])
}
